<template>
  <footer class="footer">
    <div class="container">
      <div class="row">
        <div class="col-lg-2">
          <a href="https://www.apnic.net" aria-label="APNIC home">
            <div class="footer-logo"></div>
          </a>
        </div>
        <div class="col-lg-10">
          <div class="footer-social">
            <div class="footer-social">
              Connect with us
              <ul class="">
                <li>
                  <ExternalLink
                    href="https://www.facebook.com/APNIC"
                    class="fa fa-facebook-square"
                  >
                    <span class="sr-only">Facebook</span>
                  </ExternalLink>
                </li>
                <li>
                  <ExternalLink
                    href="https://twitter.com/apnic"
                    class="fa fa-twitter"
                  >
                    <span class="sr-only">Twitter</span>
                  </ExternalLink>
                </li>
                <li>
                  <ExternalLink
                    href="https://www.youtube.com/user/apnicmultimedia"
                    class="fa fa-youtube"
                  >
                    <span class="sr-only">YouTube</span>
                  </ExternalLink>
                </li>
                <li>
                  <ExternalLink
                    href="https://www.flickr.com/photos/apnic/"
                    class="fa fa-flickr"
                  >
                    <span class="sr-only">Flickr</span>
                  </ExternalLink>
                </li>
                <li>
                  <ExternalLink
                    href="http://weibo.com/APNICrir"
                    class="fa fa-weibo"
                  >
                    <span class="sr-only">Weibo</span>
                  </ExternalLink>
                </li>
                <li>
                  <ExternalLink
                    href="http://www.slideshare.net/apnic"
                    class="fa fa-slideshare"
                  >
                    <span class="sr-only">Slideshare</span>
                  </ExternalLink>
                </li>
                <li>
                  <ExternalLink
                    href="https://www.linkedin.com/company/apnic"
                    class="fa fa-linkedin"
                  >
                    <span class="sr-only">LinkedIn</span>
                  </ExternalLink>
                </li>
                <li>
                  <ExternalLink
                    href="https://blog.apnic.net/feed/"
                    class="fa fa-rss"
                  >
                    <span class="sr-only">RSS</span>
                  </ExternalLink>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-aside">
        <small class="footer-aside-copyright"
          >©
          <span id="footer-aside-copyright-year">{{ currentYear }}</span> APNIC
          <span class="footer-aside-copyright-abn"
            >ABN&nbsp;42&nbsp;081&nbsp;528&nbsp;010</span
          >
        </small>
        <ul class="footer-aside-links">
          <li>
            <ExternalLink
              href="https://www.apnic.net/about-apnic/corporate-documents/documents/corporate/privacy/"
            >
              Privacy
            </ExternalLink>
          </li>
          <li>
            <ExternalLink
              href="https://www.apnic.net/about-apnic/organization/contact-apnic/"
            >
              Contact
            </ExternalLink>
          </li>
          <li>
            <ExternalLink href="https://www.apnic.net/get-ip/helpdesk/">
              Help Centre
            </ExternalLink>
          </li>
          <li>
            <ExternalLink href="https://www.nro.net/category/news">
              NRO News
            </ExternalLink>
          </li>
          <li>
            <ExternalLink
              href="https://www.apnic.net/about-apnic/service-updates/"
            >
              Service Status
            </ExternalLink>
          </li>
          <li>
            <ExternalLink href="https://www.apnic.net/about-apnic/employment/">
              Careers
            </ExternalLink>
          </li>
        </ul>
      </div>
    </div>
  </footer>
</template>

<script>
import ExternalLink from '../ExternalLink';

export default {
  components: {
    ExternalLink
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  }
};
</script>

<style scoped>
.footer {
  position: relative;
  background-color: #262626;
  padding: 16px;
  padding: 1rem;
  width: 100%;
  font-size: 14.4px;
  font-size: 0.9rem;
  color: #fff;
}

.row {
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}

.col-lg-10 {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}
.footer .footer-social ul {
  display: inline-block;
  margin: 0 0 0 16px;
  padding: 0;
  list-style-type: none;
  vertical-align: middle;
}
.logo-container {
  margin: 0;
  background-size: auto 28px;
  height: 25px;
}
.logo-container img {
  display: flex;
  height: 50px;
  width: 130px;
  padding: 10px;
}
.footer-aside {
  clear: both;
  margin: 16px 0 8px;
  border-top: 1px solid #e6e6e6;
  padding: 16px 0;
}
.footer-aside-copyright {
  float: left;
  margin: 0 0 16px 0;
  text-align: left;
}
.footer-aside-links {
  float: right;
  margin: 0;
  padding: 0;
  max-width: none;
  list-style-type: none;
}
.footer-logo {
  margin: 0;
  background: url('https://webdist.data.apnic.net/web-framework-theme/3.0.0/images/apnic-reverse.svg')
    no-repeat;
  background-size: auto 28px;
  height: 25px;
}
.footer-aside-copyright-abn {
  display: inline-block;
  margin-left: 16px;
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
.footer li {
  margin-right: 5px !important;
}
</style>
